import {
  mapFromDocumentOutputLocations,
  mapFromDocumentOutputLocationStatus,
  mapFromDocumentOutputLocationSummaries,
  mapToDocumentOutputLocationFolderPut,
  mapToDocumentOutputLocationPut,
} from 'mappings/documentOutputLocationMapping';
import DocumentOutputLocation, {
  DocumentOutputLocationStatus,
  DocumentOutputLocationSummary,
  DocumentOutputPurpose,
} from 'models/documentOutputLocation';
import {
  DocumentOutputLocationDTO,
  DocumentOutputLocationStatusDTO,
  DocumentOutputLocationSummaryDTO,
} from 'models/dto/documentOutputLocationDTO';
import AppError from 'utils/appError';
import http from './httpService';

export async function apiGetOutputLocations(accessToken: string): Promise<DocumentOutputLocation[]> {
  try {
    const ar = await http.get<DocumentOutputLocationDTO[]>(
      `/settings/outputlocations`,
      http.getRequestConfig(accessToken),
    );

    return mapFromDocumentOutputLocations(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetOutputLocationStatus(
  purpose: DocumentOutputPurpose,
  accessToken: string,
): Promise<DocumentOutputLocationStatus> {
  try {
    const ar = await http.get<DocumentOutputLocationStatusDTO>(
      `/settings/outputlocations/${purpose}/status`,
      http.getRequestConfig(accessToken),
    );

    return mapFromDocumentOutputLocationStatus(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/** Binds the purpose to the category and, for the general reports, the template; no listId unbinds it. */
export async function apiSetOutputLocation(
  purpose: DocumentOutputPurpose,
  listId: number | undefined,
  templateLinkId: number | undefined,
  accessToken: string,
): Promise<void> {
  try {
    await http.put(
      `/settings/outputlocations/${purpose}`,
      mapToDocumentOutputLocationPut(listId, templateLinkId),
      http.getRequestConfig(accessToken),
    );
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/** Sets the start folder inside the purpose's category; no folderDriveItemId is the category root. */
export async function apiSetOutputLocationFolder(
  purpose: DocumentOutputPurpose,
  folderDriveItemId: string | undefined,
  folderName: string | undefined,
  accessToken: string,
): Promise<void> {
  try {
    await http.put(
      `/settings/outputlocations/${purpose}/folder`,
      mapToDocumentOutputLocationFolderPut(folderDriveItemId, folderName),
      http.getRequestConfig(accessToken),
    );
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/** The category and start folder per purpose, for every signed-in user. */
export async function apiGetOutputLocationSummary(accessToken: string): Promise<DocumentOutputLocationSummary[]> {
  try {
    const ar = await http.get<DocumentOutputLocationSummaryDTO[]>(
      `/settings/outputlocations/summary`,
      http.getRequestConfig(accessToken),
    );

    return mapFromDocumentOutputLocationSummaries(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
